import React from 'react';

import { useIntl } from 'react-intl';

import { BaseTemplate } from '../base-template';
import { ApplicationFilter } from './application-filter';
import { ListApplications } from './list-applications';
import { Title } from './title';
import { AppGalleryBanner } from './app-gallery-banner';

import useAppGalleryPage from './app-gallery.page.hook';

import './style.scss';

export function AppGalleryPage() {
  const { formatMessage } = useIntl();

  const {
    categories,
    patientCategories,
    solutions,
    appTypes,
    isCategoriesLoaded,
    isSolutionsLoaded,
    isAppTypesLoaded,
    isAllApplicationsLoading,
    onCategoriesChange,
    selectedCategories,
    selectedTypes,
    selectedProducts,
    setSelectedProducts,
    setSelectedTypes,
    setSelectedCategories,
    handleFetchAllApps,
    allAppsData,
    totalAppsCount,
    hasNext,
    facing,
    selectedFacing,
    setSelectedFacing,
    onFacingChange
  } = useAppGalleryPage();

 const categoriesAll=categories.concat(patientCategories);
  return (
    <BaseTemplate>
      <AppGalleryBanner />
      <div className="marketplace_main-block">
        <div className="marketplace_main-block__continer">
          <ApplicationFilter
            categories={categoriesAll}
            solutions={solutions}
            appTypes={appTypes}
            isCategoriesLoaded={isCategoriesLoaded ? isCategoriesLoaded : false}
            isSolutionsLoaded={isSolutionsLoaded ? isSolutionsLoaded : false}
            isAppTypesLoaded={isAppTypesLoaded ? isAppTypesLoaded : false}
            onCategoriesChange={onCategoriesChange}
            selectedCategories={selectedCategories}
            selectedTypes={selectedTypes}
            selectedProducts={selectedProducts}
            setSelectedTypes={setSelectedTypes}
            setSelectedCategories={setSelectedCategories}
            setSelectedProducts={setSelectedProducts}
            loading={isAllApplicationsLoading}
            facing = {facing}
            selectedFacing={selectedFacing}
            setSelectedFacing = {setSelectedFacing}
            onFacingChange ={onFacingChange}
          />
          <div className="marketplace_main-block__content">
            {allAppsData.length > 0 && (
              <Title
                text={formatMessage(
                  {
                    id: 'app_gallety_all_apps',
                  },
                  {
                    uploaded_apps: allAppsData.length,
                    total_apps: totalAppsCount,
                  }
                )}
              />
            )}
            <ListApplications
              data={allAppsData}
              handleFetchAllApps={handleFetchAllApps}
              loading={isAllApplicationsLoading}
              total={totalAppsCount ? totalAppsCount : 0}
              hasNext={hasNext ? hasNext : 0}
            />
            { totalAppsCount <=0  && allAppsData.length <= 0 && (
             <Title text="No Apps Found" />
            )} 
          </div>
        </div>
      </div>
    </BaseTemplate>
  );
}
